import React from "react";

type CanEditProps = React.SVGProps<SVGSVGElement>;

const CanEdit = (props: CanEditProps) => {
    return (
        <svg
            id="can-edit-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 182.11 234.54"
            {...props}
        >
            <path
                fill="#c12906"
                fillRule="evenodd"
                d="M182.1,70.66v149.97c0,7.69-7.67,13.91-17.14,13.91H17.14c-9.47,0-17.14-6.22-17.14-13.91V17.14C0,7.67,7.67,0,17.14,0h94.31l70.65,70.66Z"
            />

            <path
                fill="#9b0d0a"
                fillRule="evenodd"
                d="M111.41,0h.03l70.67,70.67h-52.86c-4.73,0-9.27-1.88-12.61-5.23s-5.23-7.88-5.23-12.61V0h0Z"
            />

            <path
                fill="#fff"
                d="M137.82,179.53l-4.14-19.47L53.29,79.67l-22.61,22.61,80.39,80.39,28.72,6.11-1.97-9.25ZM129.26,183.59l-15.16-3.23,17.26-17.26,3.23,15.16c-2.57.76-4.58,2.77-5.33,5.33h0Z"
            />
        </svg>
    );
};

export default CanEdit;